/**
 * Column Configuration for Registration Tables
 * Defines all available columns and their default settings
 */

export const COLUMN_CONFIG_CAMP = {
  // ===== SYSTEM =====
  ID: {
    key: "ID",
    label: "ID",
    defaultVisible: true,
    defaultWidth: 80,
    locked: true,
    category: "System"
  },
  transaction_id: {
    key: "transaction_id",
    label: "Transaction ID",
    defaultVisible: false,
    defaultWidth: 100,
    locked: false,
    category: "System"
  },

  // ===== PARTICIPANT INFO (from club_reg_participants) =====
  camper_first_name: {
    key: "camper_first_name",
    label: "First Name",
    defaultVisible: true,
    defaultWidth: 120,
    locked: true,
    category: "Participant Info"
  },
  camper_last_name: {
    key: "camper_last_name",
    label: "Last Name",
    defaultVisible: true,
    defaultWidth: 120,
    locked: true,
    category: "Participant Info"
  },
  camper_age: {
    key: "camper_age",
    label: "Age",
    defaultVisible: true,
    defaultWidth: 90,
    locked: false,
    category: "Participant Info"
  },
  camper_gender: {
    key: "camper_gender",
    label: "Gender",
    defaultVisible: true,
    defaultWidth: 90,
    locked: false,
    category: "Participant Info"
  },
  camper_grade: {
    key: "camper_grade",
    label: "Grade",
    defaultVisible: false,
    defaultWidth: 90,
    locked: false,
    category: "Participant Info"
  },
  camper_birthday: {
    key: "camper_birthday",
    label: "Birthday",
    defaultVisible: false,
    defaultWidth: 120,
    locked: false,
    category: "Participant Info"
  },
  camper_email: {
    key: "camper_email",
    label: "Participant Email",
    defaultVisible: false,
    defaultWidth: 180,
    locked: false,
    category: "Participant Info"
  },
  camper_street: {
    key: "camper_street",
    label: "Street",
    defaultVisible: false,
    defaultWidth: 150,
    locked: false,
    category: "Participant Info"
  },
  camper_city: {
    key: "camper_city",
    label: "City",
    defaultVisible: false,
    defaultWidth: 120,
    locked: false,
    category: "Participant Info"
  },
  camper_state: {
    key: "camper_state",
    label: "State",
    defaultVisible: false,
    defaultWidth: 80,
    locked: false,
    category: "Participant Info"
  },
  camper_zip: {
    key: "camper_zip",
    label: "Zip",
    defaultVisible: false,
    defaultWidth: 100,
    locked: false,
    category: "Participant Info"
  },
  camper_t_shirt: {
    key: "camper_t_shirt",
    label: "T-Shirt",
    defaultVisible: false,
    defaultWidth: 90,
    locked: false,
    category: "Participant Info"
  },
  camper_health: {
    key: "camper_health",
    label: "Health Info",
    defaultVisible: false,
    defaultWidth: 150,
    locked: false,
    category: "Participant Info"
  },
  camper_reg: {
    key: "camper_reg",
    label: "Registration Group",
    defaultVisible: false,
    defaultWidth: 150,
    locked: false,
    category: "Participant Info"
  },
  immun_verified: {
    key: "immun_verified",
    label: "IV",
    pickerLabel: "IV (Immunization Verified)",
    defaultVisible: false,
    defaultWidth: 50,
    locked: false,
    category: "Participant Info"
  },
  custom1: {
    key: "custom1",
    label: "Custom 1",
    defaultVisible: false,
    defaultWidth: 120,
    locked: false,
    category: "Participant Info"
  },
  custom2: {
    key: "custom2",
    label: "Custom 2",
    defaultVisible: false,
    defaultWidth: 120,
    locked: false,
    category: "Participant Info"
  },

  // ===== REGISTRATION INFO =====
  reg_date: {
    key: "reg_date",
    label: "Registration Date",
    defaultVisible: true,
    defaultWidth: 150,
    locked: false,
    category: "Registration Info"
  },
  registration_name: {
    key: "registration_name",
    label: "Registration Name",
    defaultVisible: false,
    defaultWidth: 180,
    locked: false,
    category: "Registration Info"
  },
  team_name: {
    key: "team_name",
    label: "Team",
    defaultVisible: false,
    defaultWidth: 150,
    locked: false,
    category: "Registration Info"
  },

  // ===== PROGRAMS (from club_transactions_programs via GROUP_CONCAT) =====
  programs: {
    key: "programs",
    label: "Programs",
    defaultVisible: true,
    defaultWidth: 200,
    locked: false,
    category: "Programs"
  },

  // ===== PARENT/GUARDIAN INFO (from club_reg_transactions) =====
  p_first_name: {
    key: "p_first_name",
    label: "First Name",
    defaultVisible: false,
    defaultWidth: 120,
    locked: false,
    category: "Parent/Guardian Info"
  },
  p_last_name: {
    key: "p_last_name",
    label: "Last Name",
    defaultVisible: false,
    defaultWidth: 120,
    locked: false,
    category: "Parent/Guardian Info"
  },
  p_email: {
    key: "p_email",
    label: "Email",
    defaultVisible: false,
    defaultWidth: 180,
    locked: false,
    category: "Parent/Guardian Info"
  },
  p_cell_phone: {
    key: "p_cell_phone",
    label: "Cell",
    defaultVisible: false,
    defaultWidth: 130,
    locked: false,
    category: "Parent/Guardian Info"
  },
  p_home_phone: {
    key: "p_home_phone",
    label: "Home",
    defaultVisible: false,
    defaultWidth: 130,
    locked: false,
    category: "Parent/Guardian Info"
  },
  p_relation: {
    key: "p_relation",
    label: "Relation",
    defaultVisible: false,
    defaultWidth: 120,
    locked: false,
    category: "Parent/Guardian Info"
  },

  // ===== EMERGENCY CONTACT (from club_reg_transactions) =====
  c_first_name: {
    key: "c_first_name",
    label: "Emergency First Name",
    defaultVisible: false,
    defaultWidth: 120,
    locked: false,
    category: "Emergency Contact"
  },
  c_last_name: {
    key: "c_last_name",
    label: "Emergency Last Name",
    defaultVisible: false,
    defaultWidth: 120,
    locked: false,
    category: "Emergency Contact"
  },
  c_email: {
    key: "c_email",
    label: "Emergency Email",
    defaultVisible: false,
    defaultWidth: 180,
    locked: false,
    category: "Emergency Contact"
  },
  c_cell_phone: {
    key: "c_cell_phone",
    label: "Emergency Cell",
    defaultVisible: false,
    defaultWidth: 130,
    locked: false,
    category: "Emergency Contact"
  },

  // ===== PAYMENT INFO (from club_reg_transactions) =====
  total_checkout: {
    key: "total_checkout",
    label: "Total",
    defaultVisible: false,
    defaultWidth: 100,
    locked: false,
    category: "Payment Info"
  },
  payment_method: {
    key: "payment_method",
    label: "Payment Method",
    defaultVisible: false,
    defaultWidth: 130,
    locked: false,
    category: "Payment Info"
  },
  payment_transaction_id: {
    key: "payment_transaction_id",
    label: "Payment Trans ID",
    defaultVisible: false,
    defaultWidth: 150,
    locked: false,
    category: "Payment Info"
  },
  discount_code: {
    key: "discount_code",
    label: "Discount Code",
    defaultVisible: false,
    defaultWidth: 130,
    locked: false,
    category: "Payment Info"
  },
  discount_amount: {
    key: "discount_amount",
    label: "Discount Amount",
    defaultVisible: false,
    defaultWidth: 130,
    locked: false,
    category: "Payment Info"
  },

  // ===== ACTION =====
  action: {
    key: "action",
    label: "Action",
    defaultVisible: true,
    defaultWidth: 155,
    locked: true,
    category: "Action"
  }
};

export const COLUMN_CONFIG_LEAGUE = {
  first_name: {
    key: "first_name",
    label: "First Name",
    defaultVisible: true,
    defaultWidth: 120,
    locked: true,
    category: "Participant Info"
  },
  last_name: {
    key: "last_name",
    label: "Last Name",
    defaultVisible: true,
    defaultWidth: 120,
    locked: true,
    category: "Participant Info"
  },
  gender: {
    key: "gender",
    label: "Gender",
    defaultVisible: true,
    defaultWidth: 90,
    locked: false,
    category: "Participant Info"
  },
  birthday: {
    key: "birthday",
    label: "DOB",
    defaultVisible: true,
    defaultWidth: 100,
    locked: false,
    category: "Participant Info"
  },
  reg_date: {
    key: "reg_date",
    label: "Registration Date",
    defaultVisible: true,
    defaultWidth: 150,
    locked: false,
    category: "Registration Info"
  },
  fee_label: {
    key: "fee_label",
    label: "Registration Group",
    defaultVisible: true,
    defaultWidth: 150,
    locked: false,
    category: "Registration Info"
  },
  team_name: {
    key: "team_name",
    label: "Team Name",
    defaultVisible: true,
    defaultWidth: 150,
    locked: false,
    category: "Registration Info"
  },
  fee: {
    key: "fee",
    label: "Fee",
    defaultVisible: true,
    defaultWidth: 100,
    locked: false,
    category: "Payment Info"
  },
  payment_status: {
    key: "payment_status",
    label: "Status",
    defaultVisible: true,
    defaultWidth: 100,
    locked: false,
    category: "Payment Info"
  },
  grade: {
    key: "grade",
    label: "Grade",
    defaultVisible: true,
    defaultWidth: 80,
    locked: false,
    category: "Participant Info"
  },
  immun_verified: {
    key: "immun_verified",
    label: "IV",
    pickerLabel: "IV (Immunization Verified)",
    defaultVisible: false,
    defaultWidth: 50,
    locked: false,
    category: "Participant Info"
  },
  height: {
    key: "height",
    label: "Height",
    defaultVisible: false,
    defaultWidth: 65,
    locked: false,
    category: "Participant Info"
  },
  experience: {
    key: "experience",
    label: "Experience",
    defaultVisible: false,
    defaultWidth: 90,
    locked: false,
    category: "Participant Info"
  },
  coaching: {
    key: "coaching",
    label: "Will Coach?",
    defaultVisible: false,
    defaultWidth: 150,
    locked: false,
    category: "Other Info"
  },
  discount_code: {
    key: "discount_code",
    label: "Discount Code",
    defaultVisible: false,
    defaultWidth: 150,
    locked: false,
    category: "Payment Info"
  },
  action: {
    key: "action",
    label: "Action",
    defaultVisible: true,
    defaultWidth: 155,
    locked: true,
    category: "Action"
  }
};

/**
 * Get default column preferences for a sport type
 * @param {string} sportType - 'camp' or 'league'
 * @returns {object} Default preferences object
 */
export const getDefaultColumnPreferences = (sportType) => {
  const config = sportType === "camp" ? COLUMN_CONFIG_CAMP : COLUMN_CONFIG_LEAGUE;
  const columns = {};

  Object.keys(config).forEach((key) => {
    const col = config[key];
    columns[key] = {
      visible: col.defaultVisible,
      width: col.defaultWidth
    };
  });

  return { columns };
};

/**
 * Get column configuration by sport type
 * @param {string} sportType - 'camp' or 'league'
 * @returns {object} Column configuration
 */
export const getColumnConfig = (sportType) => {
  return sportType === "camp" ? COLUMN_CONFIG_CAMP : COLUMN_CONFIG_LEAGUE;
};
